/**
 * Polyfill for crypto.randomUUID()
 *
 * Safari iOS added crypto.randomUUID in version 15.4, but it may not be available
 * in certain contexts (PWA mode, tracking prevention, etc.)
 *
 * This polyfill ensures the function is always available on all browsers.
 */

const addDebug = (window as any).addDebug || console.log;

// Check if crypto.randomUUID is already available
if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
  addDebug('crypto.randomUUID: Native support detected');
} else {
  addDebug('crypto.randomUUID: Not available, installing polyfill...');

  // Polyfill implementation
  // Generates a valid UUID v4: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
  const randomUUID = (): string => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  };

  // Add to crypto object
  if (typeof crypto !== 'undefined') {
    (crypto as any).randomUUID = randomUUID;
    addDebug('crypto.randomUUID: Polyfill installed successfully');
  } else {
    // If crypto object doesn't exist at all (very old browsers)
    addDebug('crypto.randomUUID: WARNING - crypto object not found');
    (window as any).crypto = {
      randomUUID
    };
    addDebug('crypto.randomUUID: Created crypto object with polyfill');
  }
}
